import { buildUserContextKey, buildUserKey, getAllKeys, saveToLocalStorage, getFromLocalStorage, clearKey, saveForUserEncrypted, saveForUserContextEncrypted, saveForUserUnencrypted, saveForUserContextUnencrypted, getForUserUnencrypted, getForUserContextUnencrypted, existsForUser, getForUserContextEncrypted, getForUserEncrypted, clearForUser, clearForUserContext, } from '@famly/stat_ts-utils_local-storage';
const LocalStorage = {
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    buildUserKey(loginId, key) {
        return buildUserKey(loginId, key);
    },
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    buildUserContextKey(loginId, contextId, key) {
        return buildUserContextKey(loginId, contextId, key);
    },
    // --- General Local Storage Functions ---
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    getAllKeys() {
        return getAllKeys();
    },
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    saveToLocalStorage(key, data, prefix = 'famly') {
        return saveToLocalStorage(key, data, prefix);
    },
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    getFromLocalStorage(key, prefix = 'famly') {
        return getFromLocalStorage(key, prefix);
    },
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    clearKey(key, prefix = 'famly') {
        return clearKey(key, prefix);
    },
    // --- Save Encrypted Functions ---
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    saveForUserEncrypted(key, payload, withKeyPart = false) {
        return saveForUserEncrypted(key, payload, withKeyPart);
    },
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    saveForUserContextEncrypted(key, payload, withKeyPart = false) {
        return saveForUserContextEncrypted(key, payload, withKeyPart);
    },
    // --- Save Unencrypted Functions ---
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    saveForUserUnencrypted(key, payload) {
        return saveForUserUnencrypted(key, payload);
    },
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    saveForUserContextUnencrypted(key, payload) {
        return saveForUserContextUnencrypted(key, payload);
    },
    // --- Get Unencrypted Functions ---
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    getForUserUnencrypted(key) {
        return getForUserUnencrypted(key);
    },
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    getForUserContextUnencrypted(key) {
        return getForUserContextUnencrypted(key);
    },
    // --- Exists Functions ---
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    existsForUser(key) {
        return existsForUser(key);
    },
    // --- Get Encrypted Functions ---
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    getForUserEncrypted(key) {
        return getForUserEncrypted(key);
    },
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    getForUserContextEncrypted(key) {
        return getForUserContextEncrypted(key);
    },
    // --- Clear Functions ---
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    clearForUser(key) {
        return clearForUser(key);
    },
    /** @deprecated import from `@famly/stat_ts-utils_local-storage` */
    clearForUserContext(key) {
        return clearForUserContext(key);
    },
    // --- Deprecated Functions ---
    /** @deprecated use getForUserEncrypted or getForUserUnencrypted */
    getForUser(key) {
        return this.getForUserEncrypted(key);
    },
    /** @deprecated use saveForUserEncrypted or saveForUserUnencrypted */
    saveForUser(key, payload, withKeyPart = false) {
        this.saveForUserEncrypted(key, payload, withKeyPart);
    },
};
export default LocalStorage;
